﻿// @ts-nocheck
// appointment scheduling

// ========== Appointment Scheduling ==========
const SERVICE_TYPE_LABELS = {
  lawn_mowing: "🌿 Lawn Mowing",
  pest_control: "🪲 Pest Control",
  tree_trimming: "🌳 Tree Trimming",
  irrigation: "💧 Irrigation",
  fertilization: "🌱 Fertilization",
  other: "Other",
};

const STATUS_COLORS = {
  scheduled: "#3b82f6",
  completed: "#10b981",
  canceled: "#ef4444",
};

async function loadAppointments() {
  try {
    const res = await fetchWithAuth("/api/appointments");
    if (!res.ok) throw new Error("Failed to load appointments");
    const payload = await res.json();
    appointments = Array.isArray(payload) ? payload : (payload.appointments || []);
    renderScheduleCalendar();
    if (scheduleSelectedDate) renderScheduleDayDetail(scheduleSelectedDate);
    if (typeof renderServiceDashboardOverview === "function") renderServiceDashboardOverview();
  } catch (err) {
    console.error("Error loading appointments:", err);
  }
}

function schedMonthName(date) {
  return date.toLocaleString("default", { month: "long", year: "numeric" });
}

function renderScheduleCalendar() {
  const grid = document.getElementById("schedCalendarGrid");
  const label = document.getElementById("schedMonthLabel");
  if (!grid) return;

  const year = scheduleCurrentMonth.getFullYear();
  const month = scheduleCurrentMonth.getMonth();
  if (label) label.textContent = schedMonthName(scheduleCurrentMonth);

  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const todayStr = new Date().toISOString().slice(0, 10);

  // Build appointment index keyed by date
  const apptByDate = {};
  appointments.forEach((a) => {
    if (!apptByDate[a.date]) apptByDate[a.date] = [];
    apptByDate[a.date].push(a);
  });

  let cells = "";

  // Day headers
  ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].forEach((d) => {
    cells += `<div style="text-align:center; font-weight:600; font-size:0.7rem; color:var(--text-secondary); padding:4px 0;">${d}</div>`;
  });

  // Empty leading cells
  for (let i = 0; i < firstDay; i++) {
    cells += `<div></div>`;
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const dateStr = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    const isToday = dateStr === todayStr;
    const isSelected = dateStr === scheduleSelectedDate;
    const dayAppts = apptByDate[dateStr] || [];

    const dots = dayAppts.map((a) =>
      `<span style="display:inline-block;width:6px;height:6px;border-radius:50%;background:${STATUS_COLORS[a.status] || "#888"};margin:0 1px;"></span>`
    ).join("");

    const bg = isSelected ? "var(--primary, #3b82f6)" : isToday ? "rgba(59,130,246,0.15)" : "transparent";
    const color = isSelected ? "#fff" : "var(--text-primary)";
    const border = isToday && !isSelected ? "1px solid rgba(59,130,246,0.4)" : "1px solid transparent";

    cells += `
      <div onclick="selectScheduleDate('${dateStr}')" style="
        text-align:center; padding:4px 2px; border-radius:6px; cursor:pointer;
        background:${bg}; color:${color}; border:${border};
        transition: background 0.15s;
      " title="${dayAppts.length > 0 ? dayAppts.length + ' appointment(s)' : ''}">
        <div style="font-size:0.8rem; font-weight:${isToday ? '700' : '400'};">${day}</div>
        <div style="min-height:8px;">${dots}</div>
      </div>`;
  }

  grid.innerHTML = cells;
}

function selectScheduleDate(dateStr) {
  scheduleSelectedDate = dateStr;
  renderScheduleCalendar(); // re-render to update selection highlight
  renderScheduleDayDetail(dateStr);
}

function renderScheduleDayDetail(dateStr) {
  const container = document.getElementById("schedDayDetail");
  if (!container) return;

  const dayAppts = appointments.filter((a) => a.date === dateStr);
  const [year, month, day] = dateStr.split("-").map(Number);
  const displayDate = new Date(year, month - 1, day).toLocaleDateString("default", { weekday: "long", month: "long", day: "numeric", year: "numeric" });

  let html = `
    <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:0.75rem;">
      <strong style="font-size:0.9rem;">${escapeHtml(displayDate)}</strong>
      <button class="btn btn-primary btn-sm" onclick="openApptModal('${dateStr}', null)" style="font-size:0.75rem; padding:0.3rem 0.6rem;">+ Add</button>
    </div>
  `;

  if (dayAppts.length === 0) {
    html += `<p class="small-text" style="text-align:center; margin-top:1.5rem;">No appointments. Click + Add to schedule one.</p>`;
  } else {
    dayAppts.sort((a, b) => (a.time || "").localeCompare(b.time || "")).forEach((appt) => {
      const statusColor = STATUS_COLORS[appt.status] || "#888";
      html += `
        <div style="border:1px solid var(--border); border-radius:0.5rem; padding:0.75rem; margin-bottom:0.5rem; border-left:4px solid ${statusColor};">
          <div style="display:flex; justify-content:space-between; align-items:flex-start;">
            <div>
              <div style="font-weight:600; font-size:0.875rem;">${escapeHtml(appt.clientName)}</div>
              <div style="font-size:0.8rem; color:var(--text-secondary);">${SERVICE_TYPE_LABELS[appt.serviceType] || appt.serviceType}${appt.time ? " · " + appt.time : ""}${appt.assignedTo ? " · " + escapeHtml(appt.assignedTo) : ""}</div>
              <div style="font-size:0.875rem; font-weight:600; color:var(--text-primary); margin-top:0.25rem;">$${Number(appt.price).toFixed(2)}</div>
              ${appt.notes ? `<div style="font-size:0.75rem; color:var(--text-secondary); margin-top:0.25rem;">${escapeHtml(appt.notes)}</div>` : ""}
            </div>
            <div style="display:flex; flex-direction:column; gap:0.25rem; align-items:flex-end;">
              <span style="font-size:0.7rem; padding:2px 6px; border-radius:9999px; background:${statusColor}20; color:${statusColor}; font-weight:600;">${appt.status}</span>
            </div>
          </div>
          <div style="display:flex; gap:0.4rem; margin-top:0.5rem; flex-wrap:wrap;">
            <button class="btn btn-secondary btn-sm" onclick="openApptModal('${dateStr}', ${JSON.stringify(appt).replace(/"/g, '&quot;')})" style="font-size:0.7rem; padding:0.2rem 0.5rem;">Edit</button>
            ${appt.status === "scheduled" ? `<button class="btn btn-sm" onclick="completeAppt('${escapeJsSingleQuoted(appt.id)}')" style="font-size:0.7rem; padding:0.2rem 0.5rem; background:#10b981; color:#fff; border:none; border-radius:4px; cursor:pointer;">✓ Complete</button>` : ""}
            <button class="btn btn-danger btn-sm" onclick="deleteAppt('${escapeJsSingleQuoted(appt.id)}')" style="font-size:0.7rem; padding:0.2rem 0.5rem;">Delete</button>
          </div>
        </div>
      `;
    });
  }

  container.innerHTML = html;
}

function openApptModal(dateStr, existing) {
  document.getElementById("apptModalTitle").textContent = existing ? "Edit Appointment" : "New Appointment";
  document.getElementById("apptModalId").value = existing ? existing.id : "";
  document.getElementById("apptClientName").value = existing ? existing.clientName : "";
  document.getElementById("apptServiceType").value = existing ? existing.serviceType : "lawn_mowing";
  document.getElementById("apptDate").value = dateStr || (existing ? existing.date : "");
  document.getElementById("apptTime").value = existing ? (existing.time || "") : "";
  document.getElementById("apptPrice").value = existing ? existing.price : "";
  document.getElementById("apptAssignedTo").value = existing ? (existing.assignedTo || "") : "";
  document.getElementById("apptNotes").value = existing ? (existing.notes || "") : "";

  const modal = document.getElementById("apptModal");
  modal.style.display = "flex";
}

function closeApptModal() {
  document.getElementById("apptModal").style.display = "none";
}

async function saveAppt() {
  const id = document.getElementById("apptModalId").value;
  const clientName = document.getElementById("apptClientName").value.trim();
  const serviceType = document.getElementById("apptServiceType").value;
  const date = document.getElementById("apptDate").value;
  const time = document.getElementById("apptTime").value;
  const price = parseFloat(document.getElementById("apptPrice").value);
  const assignedTo = document.getElementById("apptAssignedTo").value.trim();
  const notes = document.getElementById("apptNotes").value.trim();

  if (!clientName) { alert("Client name is required."); return; }
  if (!date) { alert("Date is required."); return; }
  if (isNaN(price) || price < 0) { alert("Please enter a valid price."); return; }

  const body = {
    ...(id ? { id } : {}),
    clientName,
    serviceType,
    date,
    time: time || undefined,
    price,
    assignedTo: assignedTo || undefined,
    notes: notes || undefined,
  };

  try {
    const res = await fetchWithAuth("/api/appointments", {
      method: id ? "PUT" : "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      alert(err.error || "Failed to save appointment");
      return;
    }

    // For new appointments, also create a linked dispatch job
    if (!id) {
      const { appointment } = await res.json();
      const serviceLabel = SERVICE_TYPE_LABELS[serviceType] || serviceType;
      await fetchWithAuth("/api/jobs", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title: `${serviceLabel} — ${clientName}`,
          clientName,
          scheduledDate: date,
          assignedTo: assignedTo || undefined,
          notes: notes || undefined,
          appointmentId: appointment.id,
          status: "scheduled",
        }),
      });
      await loadJobs();
    }

    closeApptModal();
    await loadAppointments();
  } catch (err) {
    console.error("Error saving appointment:", err);
    alert("Error saving appointment.");
  }
}

async function deleteAppt(id) {
  if (!confirm("Delete this appointment?")) return;
  try {
    const res = await fetchWithAuth("/api/appointments", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    if (!res.ok) { alert("Failed to delete appointment"); return; }
    await loadAppointments();
  } catch (err) {
    console.error("Error deleting appointment:", err);
    alert("Error deleting appointment.");
  }
}

async function completeApptSilent(appt) {
  // Mark appointment completed
  await fetchWithAuth("/api/appointments", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: appt.id, status: "completed" }),
  });

  // Create invoice record
  const now = new Date();
  const month = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  const invoiceNum = `INV-${Date.now().toString(36).toUpperCase()}`;
  const serviceLabel = SERVICE_TYPE_LABELS[appt.serviceType] || appt.serviceType;

  const invoiceRes = await fetchWithAuth("/api/invoices", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      invoiceNum,
      projectName: serviceLabel,
      clientName: appt.clientName,
      month,
      subtotal: appt.price,
      taxAmount: 0,
      totalDue: appt.price,
      status: "draft",
    }),
  });

  if (invoiceRes.ok) {
    const { invoice } = await invoiceRes.json();
    await fetchWithAuth("/api/appointments", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: appt.id, invoiceId: invoice.id }),
    });
  }

  await loadAppointments();
  await loadInvoices();
}

async function completeAppt(id) {
  const appt = appointments.find((a) => a.id === id);
  if (!appt) return;

  if (!confirm(`Mark "${appt.clientName}" appointment as completed and generate an invoice for $${Number(appt.price).toFixed(2)}?`)) return;

  await completeApptSilent(appt);

  const invoiceNum = `INV-${Date.now().toString(36).toUpperCase()}`;
  alert(`✓ Appointment completed!\nInvoice created for ${appt.clientName} — $${Number(appt.price).toFixed(2)}\n\nView it in Tools → Invoice History.`);

  // Also mark any linked dispatch job as done
  const linkedJob = jobs.find((j) => j.appointmentId === id);
  if (linkedJob && linkedJob.status !== "done") {
    await fetchWithAuth("/api/jobs", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: linkedJob.id, status: "done" }),
    });
    await loadJobs();
  }
}
